module.exports = __webpack_public_path__ + "img/YSDIcon.802dc72a.png";